import React from 'react';
import { View, StyleSheet, Text } from 'react-native';
import { Title, Paragraph, Chip } from 'react-native-paper';

export default function LyricsShowcase() {
  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <View>
          <Text style={styles.kicker}>Günün Şarkı Sözü</Text>
          <Title style={styles.title}>Şamata Stüdyosu</Title>
        </View>
        <Chip compact style={styles.chip} textStyle={styles.chipText}>Özgün</Chip>
      </View>

      <Paragraph style={styles.paragraph}>
        Bu bölümde paylaşılan sözler Şamata ekibi tarafından yazılmıştır; telif içermez, sadece ilham ve deneme amaçlıdır.
      </Paragraph>

      <View style={styles.lyricsCard}>
        <Text style={styles.lyricsTitle}>“Gece Modu” (Demo)</Text>
        <Text style={styles.lyricsLine}>Şehir uyur, frekansta saklı bir ışık</Text>
        <Text style={styles.lyricsLine}>Sözler akar, karanlığa ince bir çınlık</Text>
        <Text style={styles.lyricsLine}>Dalgalarla gelir, kalbe dokunan bir tını</Text>
        <Text style={styles.lyricsLine}>Radyoda buluşur, susmayanların anı</Text>
      </View>

      <View style={styles.lyricsCard}>
        <Text style={styles.lyricsTitle}>“Yola Devam” (Demo)</Text>
        <Text style={styles.lyricsLine}>Yağmura inat, ritimle büyür adımlar</Text>
        <Text style={styles.lyricsLine}>Asfalt ıslak, ama içimiz hâlâ sıcak</Text>
        <Text style={styles.lyricsLine}>Tut elimden, şarkı bitsin istemem</Text>
        <Text style={styles.lyricsLine}>Yolda çalar bu beat, dönmüyor plak</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginTop: 20,
    marginBottom: 28,
    padding: 16,
    backgroundColor: '#0f0f0f',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#1f1f1f',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  kicker: {
    color: '#8bc6ff',
    fontSize: 13,
    letterSpacing: 0.6,
    textTransform: 'uppercase',
  },
  title: {
    color: '#ffffff',
    fontSize: 22,
    marginTop: 4,
  },
  paragraph: {
    color: '#cfd6e3',
    marginBottom: 12,
    lineHeight: 20,
  },
  chip: {
    backgroundColor: 'rgba(255,255,255,0.08)',
    borderColor: 'rgba(255,255,255,0.12)',
    borderWidth: 1,
  },
  chipText: {
    color: '#e8f0ff',
    fontSize: 12,
    fontWeight: '700',
  },
  lyricsCard: {
    backgroundColor: '#101218',
    borderRadius: 12,
    padding: 12,
    borderWidth: 1,
    borderColor: '#1f2430',
    marginTop: 8,
    gap: 4,
  },
  lyricsTitle: {
    color: '#ffffff',
    fontSize: 14,
    fontWeight: '700',
    marginBottom: 4,
  },
  lyricsLine: {
    color: '#d8e0ef',
    fontSize: 13,
    lineHeight: 20,
  },
});

